import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FieldedItemModule } from '®shared/list-item/fielded';

import { ListItemPlaceholderComponent } from './list-item-placeholder.component';

@NgModule({
  imports: [CommonModule, FieldedItemModule],
  declarations: [ListItemPlaceholderComponent],
  exports: [ListItemPlaceholderComponent],
})
export class ContainerStructureCommonModule {}
